import "./InvalidToken.scss";

import { FunctionComponent, useEffect, useState } from "react";
import Dialog from "../Dialog/Dialog";
import ButtonField from "../Button/ButtonField";
import { useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../Redux/Store/Hooks";
import { invalidToken } from "../../Redux/Slicers/InvalidToken/InvalidTokenSlice";
import { SvgIcon } from "@mui/material";
import { ReactComponent as InvalidToken } from "../../Assets/Images/InvalidToken.svg";

interface InvalidTokenDialogProps {}

const InvalidTokenDialog: FunctionComponent<InvalidTokenDialogProps> = () => {
  const nav = useNavigate();
  const dispatch = useAppDispatch();
  const { data } = useAppSelector((state) => state.InvalidToken);

  return (
    <Dialog
      open={data}
      dialogClassName="invalid_dialog"
      dialogTitleClassName="invalid_dialog_title"
      Dialog_Title={"Session Expired"}
      dialogContentClassName="invalid_dialog_content"
      Dialog_Content={
        <>
          <SvgIcon
            className="invalid_icon"
            component={InvalidToken}
            inheritViewBox
          />
          <div className="session_expired_text">Your session has expired.</div>
          <div className="redirect_text">
            You will be redirected to the Login page
          </div>
        </>
      }
      dialogActionClassName="invalid_action"
      Dialog_Actions={
        <ButtonField
          className="ok_button"
          onClick={() => {
            dispatch(invalidToken(false));
            nav("/login");
            localStorage.clear();
          }}
        >
          OK
        </ButtonField>
      }
    />
  );
};

export default InvalidTokenDialog;
